import React, { useState } from 'react'
import InvoiceService from '../../../../../services/api/invoice.service'
import DimLoader from '../../../../templates/components/DimLoader'
import APIResponse from '../../../../templates/components/APIResponse'

const CancelInvoice = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const cancelHandler = () => {
        setIsLoader(true)
        InvoiceService.deleteInvoice(props.invoiceId)
          .then(res => {
            setApiResponse(res);
          })
          .catch(err => {
            setApiResponse(err);
          }).finally(() => setIsLoader(false));
    }
    return (
        <>
        {isLoader &&
            <DimLoader loadMessage="Processing..." />}
        <div className='w-100 row d-flex'>
        <div className='col-12'>
            Are you sure you want to cancel this invoice?
          </div>
          <div className='col-12 d-flex justify-content-between mt-3'>
            <div className='col-auto'>
              <button className='btn btn-primary' onClick={(e) => { e.preventDefault(); cancelHandler()}}>Confirm</button>
            </div>
            <div className="col-auto">
              <button className='btn btn-secondary' onClick={e => { e.preventDefault(); if (props.onClose()) { props.onClose() } }}>Close</button>
            </div>
          </div>
        </div>
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default CancelInvoice